
<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("CASH_REGISTERS.CASH_REGISTERS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addCashRegister()"
                v-if="$currentUserCan($permissions.PERM_CREATE_CASH_REGISTERS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">{{
                  $t("CASH_REGISTERS.ADD_CASH_REGISTER")
                }}</span>
              </base-button>
            </div>
          </div>
        </template>

        <cash-register-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import CashRegisterListTable from "./partials/CashRegisterListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    CashRegisterListTable,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addCashRegister() {
      this.$router.push({ name: "Add CashRegister" });
    },
  },
};
</script>
